import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import BankAccountForm from '../../../BankAccountForm'
import { FormValues } from '../../../BankAccountForm/BankAccountFormSchema'
import useMutationCreateBankAccount from '@/modules/bank/api/hooks/useMutationCreateBankAccount'
import { BankAccountType, ValidateMethod } from '@/schema'
import { handlePaymentGatewayFormError } from '@/modules/bank/utils/handlePaymentGatewayFormError'
import { useState } from 'react'

export default function CreateBankAccountForm() {
	const navigate = useNavigate()
	const { mutate: createBankAccount } = useMutationCreateBankAccount()
	const [serverFieldErrors, setServerFieldErrors] = useState<
		Record<string, string>
	>({})

	const onSubmit = (values: FormValues) => {
		setServerFieldErrors({})
		createBankAccount(
			{
				payload: {
					...values,
					validateType: values.validateType as ValidateMethod[],
					bankType: values.bankType as BankAccountType,
					appCredential: values.appCredential
						? {
								deviceId: values.appCredential.deviceId!,
								pin: values.appCredential.pin!,
							}
						: undefined,
					bankApiCredential: values.bankApiCredential
						? {
								username: values.bankApiCredential.username!,
								password: values.bankApiCredential.password!,
							}
						: undefined,
				},
			},
			{
				onSuccess: () => {
					toast.success('สร้างบัญชีธนาคารสำเร็จ')
					navigate('/operator/bank-account')
				},
				onError: (error) => {
					const fieldErrors = handlePaymentGatewayFormError(error)
					if (fieldErrors) {
						setServerFieldErrors(fieldErrors)
						toast.error('ข้อมูลซ้ำ กรุณาตรวจสอบฟิลด์ที่แสดงสีแดง')
					} else {
						showErrorToast(error)
					}
				},
			},
		)
	}

	return (
		<BankAccountForm
			mode="create"
			onSubmit={onSubmit}
			serverFieldErrors={serverFieldErrors}
		/>
	)
}
